import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; // Import GFM for tables
import './SmolLM2Report.css';

const SmolLM2Report: React.FC = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/reports/SmolLM2Report.md')
      .then(response => response.text())
      .then(text => setContent(text))
      .catch(error => console.error('Error loading markdown:', error));
  }, []);  

  return (
    <div className="report-container">
      <div className="report-content">
        <div className="report-main">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>

        <div className="report-sidebar">
          <div className="sidebar-section">
            <h3>Authors</h3>
            <ul className="authors-list">
              <li>AssistantsLab Team</li>
            </ul>
          </div>

          <div className="sidebar-section">
            <h3>Resources</h3>
            <div className="resource-buttons">
              <a href="/reports/SmolLM2Report.pdf" className="resource-button pdf-button" download>
                <span className="button-icon">📄</span>
                Download PDF
              </a>
              <a 
                href="https://huggingface.co/collections/AssistantsLab/smollm2-humanized-67b455b9e4cebfcd92d8d021" 
                className="resource-button collection-button"
              >
                <span className="button-icon">🤗</span>
                Model Collection
              </a>
            </div>
          </div>

          <div className="sidebar-section">
            <h3>Details</h3>
            <div className="details-list">
              <div className="detail-item">
                <span className="detail-label">Last Updated:</span>
                <span className="detail-value">February 2024</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Version:</span>
                <span className="detail-value">1.0</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmolLM2Report;
